import { render, staticRenderFns } from "./WorkOrderAdd.vue?vue&type=template&id=506bca46&scoped=true&"
import script from "./WorkOrderAdd.vue?vue&type=script&lang=js&"
export * from "./WorkOrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderAdd.vue?vue&type=style&index=0&id=506bca46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bca46",
  null
  
)

export default component.exports